import { Component, OnInit } from '@angular/core';
import { RetailMessageService, PrintingService, SessionService, SharedService, CancelTkt, Notify } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';

// import { PrintingService } from '../../_service/printing.service';
// import { SessionService } from '../../_service/session.service';
// import { SharedService } from '../../_service/shared.service';
// import { Notify } from '../../_models/common/notify';
// import { CancelTkt } from '../../_models/retailer/retail-report';
// import { RetailMessageService } from '../_services/retail-message.service';

@Component({
  selector: 'retail-cancel',
  templateUrl: 'retail-cancel.html'
})
export class RetailCancelComponent {
  _ticket: {};
  authuser: any;
  _errorMsg: string;
  _execption: any;
  _tktDetails: any;
  _isCancel: boolean;
  _notify: Notify;

  cancelTSN: any;

  constructor(
    private _retailMessageService: RetailMessageService,
    private _printingService: PrintingService,
    private _sessionService: SessionService,
    public _sharedService: SharedService,
    private toast: CustomToast

  ) {
    this._notify = new Notify();
  }

  ngOnInit() {
  }

  validate() {
    this._tktDetails = '';
    if (!this.cancelTSN) {
      this._notify.errorMsg = "Ticket field can't be empty";
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = '';
      }, 3000);
      return false;
    }
    return true;
  }

  onCancelBtnClick() {
    if (this.validate()) {
      this._sharedService.showLoader();
      this.authuser = this._sessionService.getAuthUser()
      if (this.authuser) {
        if (this.validate()) {
          let cancelTktData = new CancelTkt();
          cancelTktData.requestAccountId = 14;
          cancelTktData.tn = this.cancelTSN;
          cancelTktData.tokenId = this.authuser.tokenNo;
          this._retailMessageService.getCancelTkt(cancelTktData).subscribe(
            data => {
              this._sharedService.hideLoader();
              if (data) {
                this._tktDetails = data;
                this._sharedService.updateUserBalance(data.bal,data.ebal);
                this._isCancel = true;
                setTimeout(() => {
                  this._isCancel = false;
                }, 3000);
                this._ticket = {
                  isCancel: true,
                  responseData: data
                }
                this._sharedService.printingObj = this._ticket;
              }
            },
            error => {
              this._sharedService.hideLoader();
              if (error.msg) {
                this._notify.errorMsg = error.msg;
              }
              else {
                this._notify.errorMsg = error.message;
              }
              this.toast.showError(this._notify.errorMsg);

              setTimeout(() => {
                this._notify.errorMsg = '';
              }, 3000);
            }
          )
        }
      }
    }
  }
  printReport() {
    this._printingService.printDetails("printingData");
  }

}




// WEBPACK FOOTER //
// ./src/app/retailer/retail-cancel/retail-cancel.ts